import React, { useEffect } from "react"
import { useLocalization } from "gatsby-theme-i18n";
import { graphql, useStaticQuery } from "gatsby";

const LocaleLoader = ({children}) => {

  const { addString, message } = useLocalization();

  const {
    common,event,nav,utils
  } = useStaticQuery(graphql`
    fragment localizedContent on LocaleNode {
      key
      ja
      fr
      en_US
      en_GB
      de
    }

    fragment localizedImages on LocaleImage {
      ja {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      fr {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      en_US {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      en_GB {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      de {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      default {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }

    query CommonLocaleStringQuery {
      common : allCommonCsv {
        nodes {
          ...localizedContent
        }
      }
      event : allEventCsv {
        nodes {
          ...localizedContent
        }
      }
      nav : allNavCsv {
        nodes {
          ...localizedContent
        }
      }
      utils : allUtilsCsv {
        nodes {
          ...localizedContent
        }
      }
    }
  `);

  useEffect(() => {
    addString('common',common.nodes);
    addString('event',event.nodes);
    addString('nav',nav.nodes);
    addString('utils',utils.nodes);

  },[common,event,nav,utils,message,addString])


return(<>{children}</>)

}

export default LocaleLoader
